module.exports = __webpack_public_path__ + "img/PRCA2_Fibroblasts.a6903ace.png";